import styled from 'styled-components';

export const FormButtonsRightContainer = styled.div`
  text-align: right;
  .ant-btn {
    min-width: 110px;
  }
`;
